module.exports = __webpack_public_path__ + "static/media/loading-dots.75be1736.svg";